module.exports = __webpack_public_path__ + "img/icon_rotate_left.1861b2b5.svg";